import React, { useMemo } from 'react'
import PageLayout from 'components/ui/page-layout'
type Props = {
  children: React.ReactNode
  isNestingExportEnabled?: boolean
}

const DataManagement = ({
  children,
  isNestingExportEnabled,
}: Props): React.ReactNode => {
  const NAV_ITEMS = useMemo(() => {
    let items = []

    if (isNestingExportEnabled) {
      items = [
        ...items,
        {
          label: 'Nesting',
          link: '/settings/nesting-export',
        },
      ]
    }

    return items
  }, [isNestingExportEnabled])
  return (
    <div className="Page">
      <div className="Page_Content">
        <PageLayout title="Data management" nav={NAV_ITEMS}>
          {children}
        </PageLayout>
      </div>
    </div>
  )
}

export default DataManagement
